import { useQuery } from 'react-query';
import eventLogService, { EventLogClinicDashboard } from '../services/eventLog.service';

const useEventLogClinicDashboard = (
  clinicId: number,
  startDate?: string,
  endDate?: string,
  userId?: string,
  locationId?: string
) => {
  const { status, data, error, isFetching, refetch } = useQuery<EventLogClinicDashboard>(
    ['eventLogClinicDashboard', clinicId, startDate, endDate, userId, locationId],
    () => eventLogService.getDashboard(clinicId, { startDate, endDate, userId, locationId }),
    {
      refetchOnWindowFocus: false,
      enabled: !!clinicId,
      keepPreviousData: true,
    }
  );

  return {
    status,
    data,
    error,
    isFetching,
    refetch,
  };
};

export default useEventLogClinicDashboard;
